export enum MCP_AuthenticationType {
Basic,
ApiKey,
ForwardHeader,
Oauth2,
Certificate,
None,
}
